import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import {
  ApexNonAxisChartSeries,
  ApexChart,
  ApexFill,
  ApexStroke,
  ApexPlotOptions,
  ApexDataLabels
} from "ng-apexcharts";

export type ChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  labels: string[];
  stroke?: ApexStroke;
  fill?: ApexFill;
  plotOptions?: ApexPlotOptions;
  dataLabels?: ApexDataLabels;
};


@Component({
  selector: 'app-credit-score-chart',
  templateUrl: './credit-score-chart.component.html',
  styleUrls: ['./credit-score-chart.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class CreditScoreChartComponent implements OnInit {
  @Input() customClass = '';

  // ✅ Always initialize default object so bindings never break
  riskChartOptions: ChartOptions = {
    series: [0],
    chart: {
      height: 350,
      type: 'radialBar',
      offsetY: -2,
      sparkline: { enabled: true }
    },
    labels: ['Loading...']
  };

  arrowIcon: string | null = null;
  arrowColor: string = '';
  constructor() { }

  ngOnInit() {
    this.setupChart();
  }

  setupChart() {
    // Business Credit Score Chart Options
    const score = 872; // change this to dynamic value as needed

    const riskLabel = this.getRiskLabel(score);
    const riskColor = this.getRiskColor(score);
    const gradientTo = this.getGradientTo(score);

    this.arrowIcon = this.getArrowIcon(score);
    this.arrowColor = riskColor;

    this.riskChartOptions = {
      series: [score],
      chart: {
        height: 350,
        // width: 200,
        type: 'radialBar',
        offsetY: -2,
        // offsetX: -5,
        sparkline: { enabled: true }
      },
      plotOptions: {
        radialBar: {
          startAngle: -135,
          endAngle: 135,
          hollow: {
            size: '55%',
            background: 'transparent'
          },
          track: {
            background: '#f1f1f1',
            strokeWidth: '100%',
            margin: 0,
          },
          dataLabels: {
            name: {
              offsetY: 30,
              fontSize: '13px',
              fontWeight: 'normal',
              fontFamily: "'DM Sans', sans-serif",
              color: riskColor,
              show: true
            },
            value: {
              show: true,
              fontSize: '32px',
              fontWeight: 'bold',
              fontFamily: "'DM Sans', sans-serif",
              color: riskColor,
              offsetY: -10,
              formatter: (val: number) => `${val}`
            }
          }
        }
      },
      fill: {
        type: 'gradient',
        gradient: {
          shade: 'light',
          type: 'horizontal',
          gradientToColors: [gradientTo],
          stops: [0, 100]
        },
        colors: [riskColor]
      },
      // stroke: {
      //   lineCap: 'round'
      // },
      stroke: {
        dashArray: 3,
        colors: [riskColor]
      },
      labels: [riskLabel]
    };
  }


  getRiskLabel(score: number): string {
    if (score >= 75) return 'Low Risk';
    if (score >= 50) return 'Medium Risk';
    return 'High Risk';
  }

  getRiskColor(score: number): string {
    if (score >= 75) return '#00C853'; // green
    if (score >= 50) return '#FFAB00'; // orange
    return '#D50000'; // red
  }

  getGradientTo(score: number): string {
    if (score >= 75) return '#00E676'; // lighter green
    if (score >= 50) return '#FFD600'; // lighter orange
    return '#FF5252'; // lighter red
  }

  getArrowIcon(score: number): string | null {
    if (score >= 75) return 'arrow-up-circle-outline';
    if (score >= 50) return 'remove-circle-outline';
    return 'arrow-down-circle-outline';
  }



}
